// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { IFormLabel } from './interfaces'

// Lodash
import omit from 'lodash/omit'

const FormLabel = ({ label, ...props }: IFormLabel) => {
  // Hook
  const { t } = useTranslation()

  return (
    <p
      className={`font-14 ${
        props?.isBold
          ? 'text-black font-weight-700'
          : props?.isDanger
          ? 'font-weight-400 text-danger'
          : 'font-weight-400 text-grey'
      }`}
      {...omit(props, ['label', 'isPhoneNumber', 'isBold', 'isDanger'])}
    >
      {props?.isPhoneNumber ? `+62${label}` : t(label || '-')}
    </p>
  )
}

export { FormLabel }
